import axios from "axios";
import { config } from "@/config/constants.js";
import router from "@/router/index.js";

export default {
  namespaced: true,
  state: {
    status: "",
    forgot_status: "",
    update_status: "",
    role: localStorage.getItem("role") || "",
    token: localStorage.getItem(config.token_key) || "",
    user: {}
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";

      if (data && data["token"]) {
        state.token = data.token;
        axios.defaults.headers.common["Authorization"] = state.token;
        localStorage.setItem(config.token_key, state.token);
        if (data["role"]) {
          state.role = data.role;
          localStorage.setItem("role", state.role);
        }
      }

      if (data && data["user"]) {
        state.user = data.user;
      }
    },
    forgot_status(state, data) {
      state.forgot_status = data;
    },
    update_status(state, data) {
      state.update_status = data;
    },
    auth_error(state) {
      state.status = "error";
      localStorage.removeItem(config.token_key);
      localStorage.removeItem("role");
      axios.defaults.headers.common["Authorization"] = state.token = "";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.role = "";
      state.user = {};
      localStorage.removeItem(config.token_key);
      localStorage.removeItem("role");
      axios.defaults.headers.common["Authorization"] = state.token = "";
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(config.api_url + "login", user)
          .then(response => {
            commit("auth_success", {
              token: response.data.user.access_token,
              role:
                response.data.user.user_role &&
                response.data.user.user_role === "admin_enterprise"
                  ? response.data.user.user_role
                  : "admin"
            });
            resolve(response.data.user);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
    verifiedPassword({ commit }, password) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
            .post(config.api_url + "verified_password", {password})
            .then(response => {
              commit("auth_success");
              resolve(response.data.user);
            })
            .catch(err => {
              reject(err);
            });
      });
    },
    forgot_password({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("forgot_status", "loading");
        axios
          .post(config.api_url + "forgot_password", user)
          .then(response => {
            commit("forgot_status", "complete");
            resolve(response.data);
          })
          .catch(err => {
            console.log(err);
            commit("forgot_status", "error");
            reject(err.response.data);
          });
      });
    },
    reset_forgot_password({ commit }) {
      return new Promise(resolve => {
        commit("forgot_status", "");
        resolve();
      });
    },
    logout({ commit }) {
      commit("logout");
      router.push("/");
    },
    me({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .get(config.api_url + "profile")
          .then(response => {
            commit("auth_success", { user: response.data.user });
            resolve(response.data.user);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
    update_password({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("update_status", "loading");
        axios
          .post(config.api_url + "update_password", data)
          .then(response => {
            commit("update_status", "complete");
            resolve(response.data);
          })
          .catch(err => {
            console.log(err);
            commit("update_status", "error");
            reject(err.response.data);
          });
      });
    },
    get_user({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("update_status", "loading");
        axios
          .post(config.api_url + "get_user", data)
          .then(response => {
            commit("update_status", "complete");
            resolve(response.data);
          })
          .catch(err => {
            console.log(err);
            commit("update_status", "error");
            reject(err.response.data);
          });
      });
    },
    delete_account({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        console.log("data",data);
        axios
          .post(config.api_url + "delete_account_email", data)
          .then(response => {
            commit("logout");
            resolve(response.data);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
  },
  getters: {
    isLoggedIn(state) {
      return state.token && state.token != undefined;
    },
    check_permission(state) {
      return (
        state.user &&
        ["sadmin", "admin", undefined].includes(state.user["role"])
      );
    },
    can_edit(state) {
      return function(section) {
        if (["projects"].includes(section)) {
          return (
            state.user &&
            state.user.role &&
            ["sadmin", "admin", "pm"].includes(state.user.role)
          );
        }
        return false;
      };
    }
  },
  modules: {}
};
